import React from 'react';
import { LocalePreference } from '../types';
import { LOCALE_PREFERENCES } from '../lib/constants';

export const LocalePreferenceContext = React.createContext<LocalePreference>(
  LOCALE_PREFERENCES['en-US'],
);
